module.exports = __webpack_public_path__ + "static/media/2_en.8d79798b.png";